import { Grid } from '@material-ui/core';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import { Colors, Paper, Text, TextButton } from 'library';
import React, { useState, useEffect } from 'react';
import { track } from 'shared';
import { IGroup, IGroupMember } from './models';
import { useMediaQuery } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import theme from 'theme';
import { AvatarGroup } from '@material-ui/lab';
import { useHistory } from 'react-router';
import MemberAvatar from './shared/MemberAvatar';
import MemberInfo from './shared/MemberInfo';
import { refreshMembers } from './shared/api';
import { isLoggedIn } from 'api/UserApi';
import useSignUpAction from 'parent-portal/login/SignUpAction';

const useStyles = makeStyles((theme: any) => ({
    blue: {
        backgroundColor: Colors.darkNavy,
    },
    avatarGroup: {
        flexWrap: 'wrap',
        flexGrow: 1,
        paddingTop: 20,
        paddingLeft: 15,
    },
    groupedAvatar: {
        marginLeft: -20,
        border: 'solid 2px #fff',
    },
    groupAvatar: {
        height: 140,
        width: 140,
        fontSize: '3rem',
        border: 'solid 2px #fff',
    },
}));

export default function GroupMembers({ groupId, group }: { groupId: string; group: IGroup | undefined }) {
    const mdDown = useMediaQuery(theme.breakpoints.down('md'));
    const classes = useStyles();
    const history = useHistory();
    const [groupMembers, setGroupMembers] = useState<IGroupMember[]>();
    const { SignUpWrapper } = useSignUpAction();

    useEffect(() => {
        refreshMembers(groupId, setGroupMembers);
    }, []);

    function seeGroupMembers() {
        if (isLoggedIn()) {
            track('User viewed group members', { group });
            history.push({ pathname: `/group/member-list/${group?.id}`, state: { groupMembers } });
        }
    }

    return (
        <SignUpWrapper>
            <Grid style={{ marginBottom: 25 }}>
                <Paper>
                    <Grid container item direction="row" justify="space-between">
                        {mdDown ? (
                            <Grid
                                container
                                item
                                direction="row"
                                spacing={3}
                                style={{ alignItems: 'center', paddingLeft: 10, maxWidth: '55%' }}
                            >
                                <AccountCircleSharpIcon style={{ color: Colors.darkNavy, marginRight: 10 }} />
                                <Text bold variant={'caption'}>
                                    {group?.member_count} Members
                                </Text>
                            </Grid>
                        ) : (
                            <Text bold variant="h2" textStyle={{ paddingBottom: 25, maxWidth: '55%' }}>
                                Members
                            </Text>
                        )}

                        <Grid item>
                            <TextButton onClick={seeGroupMembers}>see more</TextButton>
                        </Grid>
                    </Grid>
                    {mdDown ? (
                        <Grid>
                            <AvatarGroup className={classes.avatarGroup} max={8}>
                                {groupMembers?.slice(0, 8)?.map((member: IGroupMember) => (
                                    <MemberAvatar
                                        member={member}
                                        classes={`${classes.blue} ${classes.groupedAvatar}`}
                                    />
                                ))}
                            </AvatarGroup>
                        </Grid>
                    ) : (
                        <Grid container item direction="column">
                            {groupMembers?.slice(0, 3).map((member: IGroupMember) => (
                                <MemberInfo member={member} avatarClasses={`${classes.blue}`} />
                            ))}
                        </Grid>
                    )}
                </Paper>
            </Grid>
        </SignUpWrapper>
    );
}
